import * as HTTP from './http';

export const PrintRequest = async(order, device) => {
    let endpoint = `labels/request/${order}/${device}`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: labels.PrintRequest\n${e}`);
        return undefined;
    }

    return result;
}

export const PrintCustom = async(order, device, version, requestKey) => {
    let endpoint = 'labels/request/custom';

    try{
        var result = await HTTP.POST(endpoint, {
            order,
            device,
            version,
            requestKey
        });
    }catch(e){
        console.log(`CONTROLLER ERROR: labels.PrintCustom\n${e}`);
        return undefined;
    }

    return result;
}

export const GetWorkingList = async(order) => {
    try{
        return await HTTP.GET(`labels/working/${order}`);
    }catch(e){
        console.log(`CONTROLLER ERROR: labels.GetWorkingList\n${e}`);
        return undefined;
    }
}

export const SaveWorkingList = async(order, bags, expectedVersion, requestKey) => {
    try{
        return await HTTP.POST('labels/working', {order, bags, expectedVersion, requestKey});
    }catch(e){
        console.log(`CONTROLLER ERROR: labels.SaveWorkingList\n${e}`);
        return undefined;
    }
}

export const RestoreWorkingList = async(order, expectedVersion, requestKey) => {
    try{
        return await HTTP.POST('labels/working/restore', {order, expectedVersion, requestKey});
    }catch(e){
        console.log(`CONTROLLER ERROR: labels.RestoreWorkingList\n${e}`);
        return undefined;
    }
}

export const GetByOrder = async(order) => {
    let endpoint = `labels/${order}`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: labels.GetByOrder\n${e}`);
        return undefined;
    }

    return result;
}

export const PrintRequestSingle = async(label, device) => {
    let endpoint = `labels/request/single/${label}/${device}`;

    try{
        var result = await HTTP.GET(endpoint);
    }catch(e){
        console.log(`CONTROLLER ERROR: labels.PrintRequestSingle\n${e}`);
        return undefined;
    }

    return result;
}
